var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatients({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 20.5,
    viewBox: "0 0 15.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clipboard-user_1_",
    "data-name": "clipboard-user (1)",
    d: "M14.25,1.667h-.458A2.086,2.086,0,0,0,11.75,0H9.25A2.087,2.087,0,0,0,7.208,1.667H6.75A3.755,3.755,0,0,0,3,5.417V16.25A3.755,3.755,0,0,0,6.75,20h7.5A3.755,3.755,0,0,0,18,16.25V5.417A3.755,3.755,0,0,0,14.25,1.667ZM17.167,16.25a2.92,2.92,0,0,1-2.917,2.917H6.75A2.92,2.92,0,0,1,3.833,16.25V5.417A2.92,2.92,0,0,1,6.75,2.5h.833A.417.417,0,0,0,8,2.083,1.252,1.252,0,0,1,9.25.833h2.5A1.252,1.252,0,0,1,13,2.083a.417.417,0,0,0,.417.417h.833a2.92,2.92,0,0,1,2.917,2.917ZM10.5,10.833A2.5,2.5,0,1,0,8,8.333,2.5,2.5,0,0,0,10.5,10.833Zm0-4.167A1.667,1.667,0,1,1,8.833,8.333,1.668,1.668,0,0,1,10.5,6.667ZM14.654,14.9a.417.417,0,0,1-.3.5.423.423,0,0,1-.1.013.418.418,0,0,1-.4-.316,3.453,3.453,0,0,0-6.692,0,.417.417,0,1,1-.809-.2,4.286,4.286,0,0,1,8.308,0Z",
    transform: "translate(-2.75 0.25)",
    fill: "#1d2432",
    stroke: "#1d2432",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/patients.bd5c0cc5882d277820996d54d5dd4420.svg";
export { ForwardRef as ReactComponent };